Ext.ns('mx.comp');

mx.comp.EditingToolbar = Ext.extend(Ext.Toolbar, {
    readOnly: false,
    buttonsClick: Ext.emptyFn,
    name: 'editing_toolbar',

    cls: 'mx-comp-pagingtoolbar',
    labels: {
        add: 'Add',
        del: 'Delete',
    },
    uniqName: '',
    addButtonObj: null,
    delButtonObj: null,

    initComponent: function() {
        mx.comp.EditingToolbar.superclass.initComponent.call(this);
    },

    onRender: function() {
        this.autoCreate.html = '<table cellspacing="0" style="width: 180px" ><tr></tr></table>';

        mx.comp.EditingToolbar.superclass.onRender.apply(this, arguments);

        if (!this.readOnly) {
            this.addButtonObj = this.addButton({
                text: this.labels.add,
                iconCls: 'addbutton',
                name: 'mx.comp.PagingToolbar.AddButton' + this.uniqName,
                handler: this.buttonsClick.createDelegate(this, ['add']),
            });
            this.delButtonObj = this.addButton({
                text: this.labels.del,
                iconCls: 'delbutton',
                name: 'mx.comp.PagingToolbar.DeleteButton' + this.uniqName,
                handler: this.buttonsClick.createDelegate(this, ['delete']),
                disabled: true,
            });
        }
    },
});

Ext.reg('mx_editing_toolbar', mx.comp.EditingToolbar);
